import React from 'react';
import { useNavigate } from 'react-router-dom';
import { OptionButton } from '../../../utils/Button';
import cn from '../../../utils/cn';
import InstOption from '../../../utils/InstOption';
import { GetDate } from '../../../utils/Show';
import { mkRelativeUrl } from '../../../utils/URL';
import { useApiAccessToken } from '../ApiAccessTokenProvider';

function TableRow({ item }) {
    const navigate = useNavigate();
    const [showMenu, setShowMenu] = React.useState(false);
    const { handleDeleteToken } = useApiAccessToken();

    const handleShowInstMenu = (e) => {
        e.stopPropagation();
        setShowMenu((d) => !d);
    };

    return (
        <tr className={cn(`group`, { 'placeholder-mode': item?.demo })}>
            <td>
                <span>{item?.id}</span>
            </td>

            <td>
                <span>{item?.tokenName || '-----'}</span>
            </td>
            <td onClick={() => navigate(mkRelativeUrl(`/customers/${item?.user?.id}/info`))}>
                <span className="group-hover:text-secondary group-hover:font-medium cursor-pointer hover:underline text-ellipsis block w-full overflow-hidden">
                    {item?.user?.organization || '-----'}
                </span>
                <span className="text-secondary text-xs lowercase overflow-hidden text-ellipsis block w-full ">
                    {item?.user?.primaryEmail}
                </span>
            </td>
            <td>
                <span className="text-ellipsis overflow-hidden w-full block">
                    {item?.description || '------'}
                </span>
            </td>

            <td>
                <span className={item?.timeCreated ? '' : 'w-3/5 inline-block text-center'}>
                    {GetDate(item?.timeCreated) || '--'}
                </span>
            </td>
            <td>
                <span className={item?.timeExpire ? '' : 'w-3/5 inline-block text-center'}>
                    {GetDate(item?.timeExpire) || '--'}
                </span>
            </td>
            <td className="text-center capitalize">
                <span
                    className={cn({
                        'text-success': item?.status === 'active',
                        'text-warning': item?.status === 'expire-soon',
                        'text-error': item?.status === 'expire'
                    })}
                >
                    {item?.status}
                </span>
            </td>
            <td className="text-center !pr-5">
                <div className="flex flex-row w-full justify-end relative">
                    <OptionButton onClick={handleShowInstMenu} />
                    <InstOption showMenu={showMenu} setShowMenu={setShowMenu}>
                        <button type="button" onClick={(ev) => handleDeleteToken(ev, item)}>
                            Delete
                        </button>
                    </InstOption>
                </div>
            </td>
        </tr>
    );
}

function TableHeader() {
    return (
        <thead>
            <tr className="*:!cursor-default">
                <th scope="col">
                    <span className="uppercase">Id</span>
                </th>

                <th scope="col">
                    <span>Token Name</span>
                </th>
                <th scope="col">
                    <span>User</span>
                </th>
                <th scope="col" className="!cursor-default">
                    <span>Description</span>
                </th>
                <th scope="col" className="w-32 !px-1">
                    <span>Date Created</span>
                </th>
                <th scope="col" className="w-32 !px-1">
                    <span>Date Expired</span>
                </th>
                <th scope="col" className="text-center w-30">
                    <span>Status</span>
                </th>
                <th scope="col">#</th>
            </tr>
        </thead>
    );
}

function ApiAccessTokenBody() {
    const { accessTokenData } = useApiAccessToken();
    return (
        <div className="customer_page_table mb-52">
            <table className="bik-table" cellPadding={0} cellSpacing={0}>
                <TableHeader />
                <tbody className="">
                    {accessTokenData?.tokenList && accessTokenData?.tokenList?.length === 0 && (
                        <tr className="border-b border-[#1B1B1F]/10 h-12.5">
                            <td colSpan={7} className="!text-left">
                                <span className="text-primary-700 ">No Token Found!</span>
                            </td>
                        </tr>
                    )}
                    {accessTokenData?.tokenList?.map((item) => (
                        <TableRow key={item?.id} item={item} />
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default ApiAccessTokenBody;
